import { coreAPI } from "../../axios";

export const actions = {

    // TechnicalReviewUser
    GetTechnicalReviewUser(context, data){
        return coreAPI.get(`TechnicalReviewUser/My/${data.campusId}`);
    },
    CreateTechnicalReviewUser(context, data){
        return coreAPI.post(`TechnicalReviewUser/Create/${data.campusId}/${data.cycle}`, data.data);
    },
    DeleteTechnicalReviewUser(context, data){
        return coreAPI.delete(`TechnicalReviewUser/${data}`);
    },
    GetAvailableCategories(context, data){
        return coreAPI.get(`TechnicalReviewUser/GetAvailableCategories/${data}`);
    },
    GetEmployeeCategories(context, data){
        return coreAPI.get(`TechnicalReviewUser/Employee/${data.id}/${data.campusId}`);
    },
    // GetCategoryEmployees(context, data){
    //     return coreAPI.get(`TechnicalReviewUser/ItemCategory/${data.id}/${data.campusId}`);
    // },
    GetCategoryEmployees(context, data){
        return coreAPI.get(`TechnicalReviewUser/ItemCategoryGroup/${data.id}/${data.campusId}/${data.cycle}`);
    },
    GetTechnicalUserByCampus(context, data){
        return coreAPI.get(`TechnicalReviewUser/Campus/${data}`);
    },
}